import { render } from "./VideoSelectModal.vue?vue&type=template&id=a0211dd0&scoped=true"
import script from "./VideoSelectModal.vue?vue&type=script&lang=ts"
export * from "./VideoSelectModal.vue?vue&type=script&lang=ts"

import "./VideoSelectModal.vue?vue&type=style&index=0&id=a0211dd0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a0211dd0"

export default script